import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import differenceInYears from "date-fns/differenceInYears";
import {DateWithModal} from '../../../../../_common/dateWithModal';
import Child from '../../../../../constants/models/facilita/child';
import {updateDeathDeclaration} from '../../../../../actions/facilita-api';
import * as loadings from '../../../../../constants/loadings/facilita/deathDeclaration';
import $ from 'jquery';

export const ModalFamilyEnv = ({deathDeclaration, userId, isLoading}) => {
    const form = useRef(null);
    const dispatch = useDispatch();
    
    const today = new Date();

    const initialState = {
        items: deathDeclaration.childrens, 
        showNewChildForm: false,
        newChildForm : { birthDate: undefined, isHandicaped: false }
    };

    const [childrenState, setChildrenState] = useState(initialState);



    return (
        <div className="modal fade px-0" id="familyModalEnv" aria-labelledby="familyModalEnvLabel" aria-hidden="true">
            <div className="modal-dialog px-2 container-md">
                <div className="modal-content">
                    <div className="modal-header" data-dismiss="modal" aria-label="Close">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h1 className="sr-only visually-hidden">Information deceased</h1>
                            <div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="familyModalEnvLabel">ENVIRONNEMENT FAMILIAL ET PRIVÉ</div>
                        </div>
                    </div>
                    <div className="modal-body py-0">
                        <div className="flex-row align-items-center mb-2 border-bottom pb-2 border-light">
                            <p className="o-60 pr-3 my-auto">Modifier les informations qui ne sont pas à jour.</p>
                            {/* { childrenState.showNewChildForm === true ? '' : */}
                            <button type="button" className={"btn btn-alert-info ml-auto border-none" + (childrenState.showNewChildForm === true ? " disabled" : "")} disabled={childrenState.showNewChildForm === true ? "true" : ""} onClick={(e) => {
                                    e.preventDefault();
                                    setChildrenState({ ...childrenState, showNewChildForm: true });
                            }}>Ajouter <span className="d-none d-lg-inline-block">un enfant</span></button>
                            {/* } */}
                        </div>
                        {
                            childrenState.showNewChildForm === true ?
                                <form className="flex-column card p-3 bg-light flex-fill order-lg-last mb-xs mt-n2" ref={form}>
                                    <div className="form-row">
                                        <div className="form-group col">
                                            <label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance *</label>
                                            <DateWithModal isRequired={true} selectedDate={childrenState.newChildForm.birthDate} setSelectedDate={((d) => setChildrenState({...childrenState, newChildForm: {...childrenState.newChildForm, birthDate:d}}))} />
                                        </div>
                                        <div className="form-group col">
                                            <h5 className="h6 font-weight-bolder">Handicapé(e)</h5>

                                            <select className="custom-select" id="isHandicaped" tabIndex={-98} onChange={() => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, isHandicaped: !childrenState.newChildForm.isHandicaped } })}>
                                                <option value={childrenState.newChildForm.isHandicaped === false}>Non</option>
                                                <option value={childrenState.newChildForm.isHandicaped === true}>Oui</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-footer">
                                        <button type="button" className="btn btn-info mr-2" onClick={(e) => {
                                            e.preventDefault();
                                            form.current.classList.add('was-validated');
                                            if (form.current.checkValidity()){
                                                setChildrenState({...childrenState, items: childrenState.items.concat(new Child(childrenState.newChildForm)), showNewChildForm: false, newChildForm: { birthDate: undefined, isHandicaped: false }});
                                            }
                                        }}>Ajouter</button>
                                        <button type="button" className="btn btn-white-faded" onClick={(e) => {
                                            e.preventDefault();
                                            setChildrenState({ ...childrenState, showNewChildForm: false, newChildForm: { birthDate: undefined, isHandicaped: false } });
                                        }}>
                                            Annuler
                                        </button>
                                    </div>
                                </form>
                                :
                                ''
                        }
                        {
                            childrenState.items.length > 0 ?
                                <div className="grid grid-md-tight grid-lg-min g-2">
                                    {childrenState.items.map((child, index) => {
                                        return (
                                            <div className={"card p-2 border border-light flex-row" + (childrenState.items.length > 1 ? " mt-2" : "")} key={index}>
                                                <span className="block pl-1 pr-3">
                                                    <p className="h5 mb-1 mt-auto">Âge: {differenceInYears(today, new Date(child.birthDate))}</p>
                                                    <p className="h6 o-60 mb-auto">Handicapé(e): {child.isHandicaped ? 'Oui' : 'Non'}</p>
                                                </span>
                                                <button className="btn btn-sm btn-icon px-xs btn-alert-danger border-none ml-auto" onClick={(e) => {
                                                    e.preventDefault();
                                                    setChildrenState({ ...childrenState, items: childrenState.items.filter(c => c !== child), showNewChildForm: false, newChildForm: { birthDate: undefined, isHandicaped: false } });
                                                }}><i className="eva eva-trash-outline"></i></button>
                                            </div>
                                        )
                                    })}
                                </div>
                                : ''
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal" onClick={(e) => {
                            e.preventDefault();
                            setChildrenState(initialState);
                        }}>Fermer</button>
                        {
                            childrenState.showNewChildForm === true ?
                                <button type="button" className="btn btn-info disabled">Sauvegarder</button>
                            :
                                isLoading.includes(loadings.UPDATING_DECLARATION) ? 
                                    <button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder</button>

                                :
                                    <button type="button" className="btn btn-info" onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(updateDeathDeclaration(userId, {
                                            ...deathDeclaration,
                                            childrens: childrenState.items,
                                        })).then(() => $('.modal').modal("hide"));
                                    }}>Sauvegarder</button>
						}
                    </div>
                </div>
            </div>
        </div>
    )
}